import { Component, inject, Input } from '@angular/core'

import { LocaleModule } from 'common/locale'
import { LoggerFactory } from 'common/log'
import { RouteLoggerService, WindowLocationService } from 'common/util'

@Component({
  selector: 'navigation-error-view',
  templateUrl: './navigationErrorView.component.html',
  styleUrls: ['./navigationErrorView.component.scss'],
  imports: [
    LocaleModule,
  ],
})
export class NavigationErrorViewComponent {
  @Input() error: any
  reason = ''
  reasonText = ''
  reasonUrl = ''
  reasonCode = 0
  readonly logger = inject(LoggerFactory).create('NavigationErrorViewComponent')
  readonly #location = inject(WindowLocationService)

  constructor (routerLogger: RouteLoggerService) {
    this.error = routerLogger.lastError
  }

  reload (): void {
    this.#location.reload()
  }

  async ngOnInit () {
    let error = this.error
    if (!error) {
      return
    }

    if (error.response) {
      error = error.response
    }

    this.reason = 'unknown'
    if (error.status) {
      this.reasonUrl = error.config?.url ?? error.url
      if (error.status === 404) {
        this.reason = 'not-found'
      } else if (error.status === 500) {
        this.reason = 'server-error'
      } else if (error.status === -1) {
        this.reason = 'connection-error'
      } else {
        this.reason = 'http-error'
        this.reasonCode = error.status
        this.reasonText = error.statusText
      }
    } else {
      this.reason = 'misc'
      this.reasonText = error
    }

    this.logger.log('Reason:', this.reason, this.reasonText)
    this.logger.log('Reason code:', this.reasonCode)
    this.logger.log('URL:', this.reasonUrl)
  }
}
